module.exports = __webpack_public_path__ + "static/media/facebook-dark.a8fb160f.svg";